export enum LanguageSelectorVariant {
  Button = "button",
  Dropdown = "dropdown",
}
